import { render, staticRenderFns } from "./widgetContentList.vue?vue&type=template&id=af49a6e2&"
import script from "./widgetContentList.vue?vue&type=script&lang=js&"
export * from "./widgetContentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports